var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clear-token-page"},[_c('h2',[_vm._v("获取登录信息")]),_c('p',[_vm._v("正在获取浏览器中的登录信息...")])])}]

export { render, staticRenderFns }